<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
      :style="{
        backgroundImage: `url(${backgroundImage})`
      }"
    >
      <!-- begin:: Content -->
      <h1
        class="font-size-sm-100 font-weight-boldest text-white mt-15"
        style="font-size: 60px;"
      >
        {{ $t("GENERIC.402") }}
      </h1>

      <div class="row mt-6">
        <div class="col-lg-1">
          <button
            class="btn btn-pill btn-white button-form button-form-primary"
            onclick="window.close()"
          >
            <inline-svg
              src="/media/icons/arrow-return-primary.svg"
              class="mr-3"
            />
            {{ $t("GENERIC.CLOSE") }}
          </button>
        </div>
      </div>
      <!-- end:: Content -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Error-402",
  mounted() {},
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/imagen-bienvenido.jpg";
    }
  }
};
</script>
